import { StyleSheet } from 'aphrodite';
import { BreakPoints } from '../../../../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	container: {
		background: '#F9F9F9',
		height: '100%',
	},
	surveyContent: {
		margin: '0 auto',
		width: 370,
		[BreakPoints.phoneCompactWidth]: {
			width: 'calc(100% - 32px)',
		},
	},
});
